import { create } from 'zustand';

export const ChatType = {
  job: 'job',
  connie: 'connie',
  document: 'document',
  quote: 'quote',
  contact: 'contact',
} as const;

export type ChatType = (typeof ChatType)[keyof typeof ChatType];

export type ChatStateMap = {
  job: {
    isOpen: boolean;
    contactId: string | null;
    sessionId: string | null;
    entityId: string | null;
    jobReference: string | null;
    isNewSession: boolean;
  };
  connie: {
    isOpen: boolean;
    sessionId: string | null;
    isNewSession: boolean;
  };
  quote: {
    sessionId: string | null;
    entityId: string | null;
    isNewSession: boolean;
  };
  document: {
    sessionId: string | null;
    entityId: string | null;
    isNewSession: boolean;
  };
  contact: {
    isOpen: boolean;
    contactId: number | null;
    sessionId: string | null;
    isNewSession: boolean;
  };
};

interface ChatsContextType {
  chatState: ChatStateMap;
  updateChatState: <T extends ChatType>(
    chatType: T,
    data: Partial<ChatStateMap[T]>
  ) => void;
}

export const useChats = create<ChatsContextType>(set => ({
  chatState: {
    job: {
      isOpen: false,
      contactId: null,
      sessionId: null,
      entityId: null,
      jobReference: null,
      isNewSession: false,
    },
    connie: {
      isOpen: false,
      sessionId: null,
      isNewSession: true,
    },
    quote: {
      sessionId: null,
      entityId: null,
      isNewSession: true,
    },
    document: {
      sessionId: null,
      entityId: null,
      isNewSession: true,
    },
    contact: {
      isOpen: false,
      contactId: null,
      sessionId: null,
      isNewSession: false,
    },
  },
  updateChatState: (chatType, data) =>
    set(state => ({
      ...state,
      chatState: {
        ...state.chatState,
        [chatType]: { ...state.chatState[chatType], ...data },
      },
    })),
}));
